import { Queue } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#a855f7";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="Fila"
    accent={accent}
    icon={<Queue sx={{ width: 15, height: 15, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={valuePill(accent)}>
      {data?.queue?.name || "Fila não selecionada"}
    </div>
  </NodeCard>
));
